import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25.724 7.057 12 20.781l-5.724-5.724a1.332 1.332 0 1 0-1.885 1.885l6.667 6.667a1.332 1.332 0 0 0 1.885 0L27.61 8.942a1.332 1.332 0 1 0-1.885-1.885h-.001Z" }));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
